<template>
    <div class="mb-2 col-md-6 d-flex align-items-center" v-if="isVisible">
        <el-checkbox
            :value="pendingAsBoolean"
            @input="onChange"
            class=""
        >
            {{ placeholder }}
        </el-checkbox>
    </div>
</template>

<script>
    import BaseFilter from "./base-filter";

    export default {
        extends: BaseFilter,

        computed: {
            pendingAsBoolean() {
                return this.pending === '1';
            }
        },

        methods: {
            prepareValue(value) {
                return value ? '1' : null;
            },

            /**
             * @param {*} value
             * @return {*}
             */
            getLabelValue(value) {
                return  this.labelDisplay;
            },
        },
    }
</script>
